module.exports = __webpack_public_path__ + "images/feature/feature_1027_1-5d139f4aa5d2be6876a7a7477293d93f.png";